// Change these constants if you want to change the default
// price of implementation services.
//
// IMPORTANT: you will also need to change the default values in the
// API service and dashboard.

export const SERVICES_DAY_RATE = 700;
export const SERVICES_HOUR_RATE = 115;
